import React, { useState } from "react";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TenderProcessTracker from "../../components/TenderProcessTracker/TenderProcessTracker";
import CreatableComboBox from "../../components/CreatableComboBox/CreatableComboBox";
import CommentBox from "../../components/CommentBox/CommentBox";
import { createTender } from "../../api/api";
import { 
  NewTenderPageContainer,
  Header,
  SubHeader,
  InitializeButton,
  InputsContainer
} from './NewTenderPage.styles';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../components/ToastProvider/ToastProvider';

export default function NewTenderPage() {
  const [loading, setLoading] = useState(false);
  const [selectedBrokerId, setSelectedBrokerId] = React.useState(null);
  const [selectedEmployerId, setSelectedEmployerId] = React.useState(null);
  const [comment, setComment] = React.useState("");
  const { showToast } = useToast();
  const navigate = useNavigate();
  
  const handleBrokerChange = (value) => {
    setSelectedBrokerId(value.id);
  };
  
  const handleEmployerChange = (value) => {
    setSelectedEmployerId(value.id);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };
  
  const handleInitializeClick = async () => {
    setLoading(true);
    let tender;
    try {
      tender = await createTender(selectedEmployerId, selectedBrokerId, comment);
      showToast('New Tender added successfully', 'success', 2000);
    } catch (error) {
      if (error.isAuthExpired) return;
      console.error("Error creating tender:", error);
      showToast('Enter required values.', 'error');
      setLoading(false);
      return;
    }
    navigate(`/${tender.id}/source-documents`);
  };

  const isDisabled = !selectedBrokerId || !selectedEmployerId;

  return (
    <NewTenderPageContainer data-testid="main-content">
      <Breadcrumbs />
      <TenderProcessTracker />
      <Header data-testid="header" >Tender Initialization</Header>
      <SubHeader data-testid="subheader" >Select an Employer and Broker, alternatively please create a new Employer and Broker.</SubHeader>

      {loading ? (
        <img src="/Icons/jigsaw-loading.gif" alt="Loading"  data-testid="loading-spinner"/>
      ) : (
        <>
          <InputsContainer>
            <CreatableComboBox onBrokerChange={handleBrokerChange} onEmployerChange={handleEmployerChange} />
            <CommentBox onChange={handleCommentChange} />
          </InputsContainer>
          <InitializeButton 
            data-testid="initializebutton" 
            onClick={handleInitializeClick}
            disabled={isDisabled}
          >
            Initialize
        </InitializeButton>
        </>
      )}
    </NewTenderPageContainer>
  );
}